import React from 'react'
import { Tag, Button, Switch, Popconfirm, Space } from 'antd'

const TOPIC_COLORS = {
  policy: 'red',
  scope: 'blue',
  pricing: 'gold',
  how_it_works: 'green',
  faq: 'default',
  escalation: 'purple'
}

const SERVICE_LABELS = {
  duty: 'Import duty',
  insurance: 'Insurance',
  tracking: 'Shipment tracking',
  cars: 'Car sales',
  general: 'General'
}

const SERVICE_COLORS = {
  duty: 'geekblue',
  insurance: 'cyan',
  tracking: 'orange',
  cars: 'magenta',
  general: 'default'
}

/* eslint-disable react/display-name */
export const columns = (onEdit, onToggleActive, onDelete, togglingId, deletingId) => [
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    width: 260,
    render: (text, record) => (
      <div>
        <b>{text}</b>
        {record.isAlwaysOn && (
          <Tag color="volcano" style={{ marginLeft: 8 }}>
            Always-on
          </Tag>
        )}
        {record.trigger && (
          <div style={{ fontSize: 12, color: '#888' }}>{record.trigger}</div>
        )}
      </div>
    )
  },
  {
    title: 'Service',
    dataIndex: 'service',
    key: 'service',
    width: 150,
    filters: Object.keys(SERVICE_LABELS).map(s => ({
      text: SERVICE_LABELS[s],
      value: s
    })),
    onFilter: (value, record) => record.service === value,
    render: service => (
      <Tag color={SERVICE_COLORS[service] || 'default'}>
        {SERVICE_LABELS[service] || service}
      </Tag>
    )
  },
  {
    title: 'Topic',
    dataIndex: 'topic',
    key: 'topic',
    width: 130,
    filters: Object.keys(TOPIC_COLORS).map(t => ({ text: t, value: t })),
    onFilter: (value, record) => record.topic === value,
    render: topic => <Tag color={TOPIC_COLORS[topic] || 'default'}>{topic}</Tag>
  },
  {
    title: 'Priority',
    dataIndex: 'priority',
    key: 'priority',
    width: 90,
    sorter: (a, b) => (a.priority || 0) - (b.priority || 0)
  },
  {
    title: 'Active',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 100,
    filters: [
      { text: 'Active', value: true },
      { text: 'Inactive', value: false }
    ],
    onFilter: (value, record) => record.isActive === value,
    render: (isActive, record) => {
      // Always-on entries get a confirm before being switched off (Property 3).
      const sw = (
        <Switch
          checked={isActive}
          loading={togglingId === record.id}
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      )
      if (isActive && record.isAlwaysOn) {
        return (
          <Popconfirm
            title="This is an always-on policy entry. Deactivate it?"
            okText="Deactivate"
            okButtonProps={{ danger: true }}
            onConfirm={() => onToggleActive(record)}
          >
            {sw}
          </Popconfirm>
        )
      }
      return <span onClick={() => onToggleActive(record)}>{sw}</span>
    }
  },
  {
    title: 'Updated',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    width: 160,
    render: updatedAt =>
      updatedAt ? new Date(updatedAt).toLocaleString() : '—'
  },
  {
    title: 'Action',
    key: 'action',
    fixed: 'right',
    width: 160,
    render: (_, record) => (
      <Space>
        <Button size="small" onClick={() => onEdit(record)}>
          Edit
        </Button>
        <Popconfirm
          title={
            record.isAlwaysOn
              ? 'Delete this ALWAYS-ON policy entry? This may weaken the assistant.'
              : 'Delete this entry?'
          }
          okText="Delete"
          okButtonProps={{ danger: true }}
          onConfirm={() => onDelete(record)}
        >
          <Button size="small" danger loading={deletingId === record.id}>
            Delete
          </Button>
        </Popconfirm>
      </Space>
    )
  }
]
